export const INITIALIZE_OAUTH_PAGE = 'initialize-oauth-page';
const initializeOAuthPage = () => ({ type: INITIALIZE_OAUTH_PAGE });
export default initializeOAuthPage;
